<template>
    <div class="details-panel details-panel__white  mb-1" v-if="isNotEmpty" :id="'singleUpgradeBox_' + product">
        <div class="details-panel__body--header">
<!--            <span class="details-panel__body&#45;&#45;headerimg">-->
<!--                <img v-bind:src="'images/program-icons/' + products[product].title.replace(' ', '-') + '.svg'" alt="icon">-->
<!--            </span>-->
            {{ getTranslation('single-upgrade-vue', 'single_upgrade_product', {name: products[product].title}) }}
        </div>
        <div class="details-panel__body">

            {{ getTranslation('single-upgrade-vue', 'upgrade_perpetual_licences') }}
            <br> <br>
            <div class="custom-control custom-checkbox b-custom-control-lg">
                <input
                    type="checkbox"
                    :id="'singleUpgrade_' + product"
                    v-model="productStatus"
                    value = "1"
                    @click="toggleProduct()"
                    class="custom-control-input"
                    :name="'singleUpgradeChecked[' + product + ']'"
                >
                <label :for="'singleUpgrade_' + product" class="custom-control-label d-flex flex-wrap">
                    {{ getTranslation('single-upgrade-vue', 'purchase_single_upgrade') }}
                    <span class="ml-auto text-black">{{ priceFormat(singleUpgradeDisplayPrice, true, true) }}</span>
                </label>
                <div class="note note-warning mt-2" v-if="checkCannotPurchase && 0">
                    {{ getTranslation('single-upgrade-vue', 'no_licences_selected_for_upgrade') }}
                </div>
            </div>
            <div v-if="typeof (programData) != 'undefined'">
                <div class="details-panel__body--content">
                    <a style="max-width:201px;white-space: nowrap;"  href="javascript:;" v-b-toggle="'singleUpgradeCollapse_' + product" class="details-panel__body--trigger">
                        {{ getTranslation('single-upgrade-vue', 'selected_programs') }}
                        <span class="collapse-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-caret-down fa-w-10 fa-2x"><path fill="currentColor" d="M287.968 160H32.038c-28.425 0-42.767 34.488-22.627 54.627l127.962 128c12.496 12.496 32.758 12.497 45.255 0l127.968-128C330.695 194.528 316.45 160 287.968 160zM160 320L32 192h256L160 320z"></path>
                            </svg>
                        </span>
                    </a>
                </div>
                <b-collapse :id="'singleUpgradeCollapse_' + product" class="details-panel__body--collapse" >

                    <div v-for="key in existingKeys" class="col-12 view-extras" v-if="hasLicences(key.key_id)">
                        <div class="custom-control custom-checkbox">
                            <input
                                type="checkbox"
                                :id="'toggle_key' + product + '_' + key.key_id"
                                v-model="keyStatus[key.key_id]"
                                @click="toggleKey(key.key_id)"
                                class="custom-control-input"
                            >
                            <label :for="'toggle_key' + product + '_' + key.key_id" class="custom-control-label">
                                #{{ key.key_id }} {{ key.key_name }}
                            </label>
                        </div>

                        <div
                            v-for="(program, index) in programData.info"
                            class="col-12 view-extras"
                            v-if="program.key == key.key_id && program.parent_program_id == 0"
                        >
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    :id="'single_upgrade_' + product + '_' + index"
                                    @click="toggleSingleUpgradeProgram(product, index)"
                                    v-model="programData.info[index].selected"
                                    :value = "1"
                                    :name = "'single_upgrade[' + product + '][' + program.user_licence_id + ']'"
                                    class="custom-control-input"
                                >
                                <label
                                    :for="'single_upgrade_' + product + '_' + index"
                                    class="custom-control-label"
                                >
                                    <span :class="program.maintenance_excluded ? 'maintenance_excluded' : ''">{{ program.name }} </span> <span v-if="program.quantity > 1">( {{ program.quantity }} )</span>
                                    {{ program.version }} -> {{latestProductVersions[product]}}
                                    <b>{{ priceFormat(Number(getSingleUpgradePrice(program) * Number(program.quantity)), false, true) }}</b>
                                </label>
                            </div>
                            <div
                                v-for="(programModule, index) in programData.info"
                                class="col-12 view-extras"
                                v-if="programModule.key == key.key_id && programModule.parent_program_id == program.id"
                            >
                                <div class="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        :id="'single_upgrade_' + product + '_' + index"
                                        @click="toggleSingleUpgradeProgram(product, index)"
                                        v-model="programData.info[index].selected"
                                        :value = "1"
                                        :name = "'single_upgrade[' + product + '][' + programModule.user_licence_id + ']'"
                                        class="custom-control-input"
                                        disabled
                                    >
                                    <label :for="'single_upgrade_' + product + '_' + index" class="custom-control-label">
                                        {{ programModule.name }} {{ programModule.version }} -> {{ latestProductVersions[product] }} <b>{{ priceFormat(Number(getSingleUpgradePrice(programModule)), false, true) }}</b>
                                    </label>
                                </div>
                            </div>
                        </div>

                    </div>

                </b-collapse>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            resetHardlocksAndCartStep() {
                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
                this.$store.commit('emptyHardlocks');
                this.$store.commit('setMustConfirm', 0);
            },
            addToCart(product) {
                this.resetHardlocksAndCartStep();
            },
            toggleSingleUpgradeProgram(product, index) {
                 //find submodules
                let self = this;
                let program = this.singleUpgrade[this.product].info[index];
                this.programData.info.forEach(function(l, i) {
                    if (l.product == self.product && l.key == program.key && l.parent_program_id == program.id) {
                        self.$store.commit('toggleSingleUpgradeProgram', {
                            product: product,
                            index: i
                        });
                    }
                });
                //toggle product
                this.$store.commit('toggleSingleUpgradeProgram', {
                    product: product,
                    index: index
                });

                this.$store.commit('toggleSingleUpgradePrice', {
                    product: product,
                    price: this.singleUpgradePrice
                });
                if (this.singleUpgradePrice == 0) {
                    this.productStatus = false;
                    this.$root.$emit("toggleProductCart", {product: this.product, status:false});
                } else {
                    this.productStatus = true;
                    this.$root.$emit("toggleProductCart", {product: this.product, status:true});
                }
                this.resetHardlocksAndCartStep();
            },
            hasLicences(key) {
                if (typeof this.singleUpgrade[this.product] == 'undefined') {
                    return false;
                }
                let found = this.singleUpgrade[this.product].info.find(l => l.key == key);
                if (typeof found !== 'undefined') {
                    return true;
                }
                return false;
            },
            toggleKey(key) {
                let self = this;
                this.$store.state.cart.singleUpgrade[this.product].info.forEach(function(l, index) {
                    if (l.product == self.product && l.key == key && l.selected == self.keyStatus[key] && l.parent_program_id == 0) {
                        self.toggleSingleUpgradeProgram(self.product, index);
                    }
                });
                this.keyStatus[key] = !this.keyStatus[key];
                return true;
            },
            toggleProduct() {
                let self = this;
                let status = this.singleUpgradePrice ? true : false;
                this.$store.state.cart.singleUpgrade[this.product].info.forEach(function(l, index) {
                    if (l.product == self.product && l.selected == status && l.parent_program_id == 0) {
                        self.toggleSingleUpgradeProgram(self.product, index);
                    }
                });

                this.productStatus = !this.productStatus;
                if (!_.isNil(this.keyStatus)) {
                    _.forEach(this.keyStatus, function(k, i) {
                        self.keyStatus[i] = !status;
                    });
                }
                this.$root.$emit("toggleProductCart", {product: this.product, status:this.productStatus});

                return true;
            }
        },
        mounted() {
            let self = this;

            this.programData = this.$store.state.cart.singleUpgrade[this.product];

            if (!_.isUndefined(this.programData) && this.singleUpgrade.length) {
                this.programData.info.forEach(function(l, index) {
                    l.price = self.singleUpgrade[self.product].info[index].price;
                });
            }

            if ( Object.keys(this.existingKeys).length !== 0) {
                this.existingKeys.forEach(function (k) {
                    if (typeof self.programData != 'undefined') {
                        let found = self.programData.info.find(l => l.selected == false);
                        if (typeof found !== 'undefined') {
                            self.keyStatus[k.key_id] = false;
                        } else {
                            self.keyStatus[k.key_id] = true;
                        }
                    }
                });
            }
            if (this.singleUpgradePrice) {
                this.productStatus = true;
            }
            this.$root.$on("toggleProduct",  (item, response) => {
                if (item == this.product) {
                    this.toggleProduct();
                }
            });
        },

        computed: {
            singleUpgradePrice() {
                if (_.isNil(this.programData)) {
                    return 0;
                }
                if (_.isNil(this.programData.info)) {
                    return 0;
                }
                let total = 0;
                _.forOwn(this.programData.info, function(pr, key) {
                    if (pr.selected == true) {
                        total += Number(pr.price)
                    }
                });
                return total;
            },
            singleUpgradeDisplayPrice() {
                let self = this;
                if (_.isNil(this.programData)) {
                    return 0;
                }
                if (_.isNil(this.programData.info)) {
                    return 0;
                }
                let total = 0;
                _.forOwn(this.programData.info, function(pr, key) {
                    if (pr.selected == true) {
                        total += _.toNumber(self.getSingleUpgradePrice(pr)) * _.toNumber(pr.quantity);
                    }
                });
                return total;
            },
            isNotEmpty() {
                if (typeof (this.$store.state.cart.singleUpgrade[this.product]) == 'undefined') {
                    return false;
                }
                return true;
            },
            checkCannotPurchase() {
                let status = true;
                if (typeof (this.$store.state.cart.singleUpgrade[this.product]) != 'undefined') {
                    this.$store.state.cart.singleUpgrade[this.product].info.forEach(function(l, index) {
                        if (l.selected) {
                            status = false;
                        }
                    });
                }
                return status;
            }
        },
        watch: {
            'programData': {
                handler: function (newValue, oldValue) {
                    let status = false;
                    if (this.singleUpgradePrice) {
                        status = true;
                    }

                    this.productStatus = status;
                    this.$root.$emit("toggleProductCart", {product: this.product, status:this.productStatus});

                    if ( Object.keys(this.existingKeys).length !== 0) {
                        this.existingKeys.forEach(function (k) {
                            if (typeof self.programData != 'undefined') {
                                let found = self.programData.info.find(l => l.selected == false);
                                if (typeof found !== 'undefined') {
                                    self.keyStatus[k.key_id] = false;
                                } else {
                                    self.keyStatus[k.key_id] = true;
                                }
                            }
                        });
                    }
                },
                deep: true,
                immediate: true,
            },
        },
        data() {
            return {
                singleUpgrade: JSON.parse(window.singleUpgrade),
                products: window.jsonProducts,
                existingKeys: JSON.parse(window.existingKeys),
                keyStatus: {},
                productStatus: false,
                latestProductVersions: window.latestProductVersions,
                programData: {},
                loggedInUser: window.loggedInUser
            };
        },
        props: {
            product: {
                type: [Number, String],
                required: true
            }
        }
    }
</script>

<style>
    .maintenance_excluded {
        color: grey;
    }
</style>
